<template>
  <div>
    <h1 class="mb-0">Sign in</h1>
    <p>Enter your email address and password to access the panel.</p>
    <b-alert :show="alertshow" variant="danger">
  <div class="iq-alert-text">{{ alertMessage}}</div>
</b-alert>
    <form class="mt-4" v-on:submit="submit">
      <div class="form-group">
        <label for="exampleInputEmail1">Email address</label>
        <input type="text" v-model="email" class="form-control mb-0" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" autocomplete="username email">
      </div>
      <div class="form-group">
        <label for="exampleInputPassword1">Password</label>
        <a :href="forgetLinkUrl" class="float-right">Forgot password?</a>
        <b-input-group>
                  <b-form-input
                  v-model="password"
                  type="password"
                  id="newpassword"
                  autocomplete="new-password"
                  class="form-control form-control-lg"
                  placeholder="**********"
                />
                <b-input-group-append is-text @click="togglePassword('newpassword')">
                    <i v-show="showPassword == true" class="fa fa-eye" id="togglePassword" title="hide password"></i>
                    <i v-show="showPassword == false" class="fa fa-eye-slash" id="togglePassword" title="show password"></i>
                  </b-input-group-append>
                </b-input-group>
      </div>
      <div class="d-inline-block w-100">
        <div class="custom-control custom-checkbox d-inline-block mt-2 pt-1">
          <input type="checkbox" class="custom-control-input" v-model="remember_me" id="customCheck1">
          <label class="custom-control-label" for="customCheck1">Remember Me</label>
        </div>
        <button type="submit" class="btn btn-primary float-right">Sign in</button>  
      </div>
      <div class="sign-info">
        <span class="dark-color d-inline-block line-height-2">Don't have an account? <a :href="linkUrl">Sign up</a></span>
        <ul class="iq-social-media">
          <li><a href="#"><i class="ri-facebook-box-line"></i></a></li>
          <li><a href="#"><i class="ri-twitter-line"></i></a></li>
          <li><a href="#"><i class="ri-instagram-line"></i></a></li>
        </ul>
      </div>
    </form>
  </div>
</template>
<script>
import UserControl from '../../../Apis/usercontrol'

export default {
  name: 'Login',
  data () {
    return {
      linkUrl: '/auth/signup',
      forgetLinkUrl: '/auth/password-reset1',
      email: '',
      password: '',
      remember_me: false,
      showPassword: false,
      alertshow:false,
      alertMessage:'Please Enter valid email or password'
    }
  },
  mounted(){
    
    if(this.$route.query.token){

    this.token = this.$route.query.token; 
    this.verifiedtoken(this.token);
    }
  },
  methods: {
    async verifiedtoken(){
     let response = await UserControl.verifiedEmailToken({"token":this.token})
     if(response.status == 201)
     this.$toast.info('Email Varified Successfully!', {
                    position: 'top-center'
                });
      
    },
    async submit (event) {
      event.preventDefault();
      const formData = new FormData()
      formData.append('email', this.email)
      formData.append('password', this.password)
      formData.append('remember_me',Number(this.remember_me))
      try {
        let response = await UserControl.login(formData);
        if(response.data.accessToken){
          localStorage.setItem('accessToken', response.data.accessToken)
          localStorage.setItem('user', JSON.stringify(response.data.user))
          localStorage.setItem('activityCheckActive', 'true');
          this.$router.push('/')
        }
        else{
          this.alertMessage = response.data.message;
          this.alertshow=true;
        }
      } catch (e) {
        this.alertshow=true;
        
      }
    },
    togglePassword(id){
          const password = document.getElementById(id)
;
          this.showPassword = this.showPassword === false ? true: false
          const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
          password.setAttribute('type', type);
        },
  }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
}
</script>
